import { render, staticRenderFns } from "./price-resume-data.vue?vue&type=template&id=109c8d11&scoped=true"
import script from "./price-resume-data.vue?vue&type=script&lang=js"
export * from "./price-resume-data.vue?vue&type=script&lang=js"
import style0 from "./price-resume-data.vue?vue&type=style&index=0&id=109c8d11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109c8d11",
  null
  
)

export default component.exports